import React, { Component } from "react";
import { Dropdown } from "react-bootstrap";
import DropdownMenu from "react-bootstrap/DropdownMenu";
import DropdownToggle from "react-bootstrap/DropdownToggle";
import { Link } from "react-router-dom";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  setLayoutSettings,
  setDefaultSettings,
} from "app/redux/actions/LayoutActions";
import { logoutUser } from "app/redux/actions/UserActions";
import { withRouter } from "react-router-dom";
import localStorageService from "app/services/localStorageService";

import { merge } from "lodash";

import { GetEscola } from "../../views/escola/EscolaService";

class Layout1Header extends Component {
  state = {
    shorcutMenuList: [
      {
        icon: "i-Shop-4",
        link: "#",
        text: "Home",
      },
    ],
    notificationList: [
      {
        icon: "i-Speach-Bubble-6",
        title: "New message",
        description: "James: Hey! are you busy?",
        time: "2019-10-30T02:10:18.931Z",
        color: "primary",
        status: "New",
      },
    ],
    showSearchBox: false,
    usuario: "",
    icone: "",
    anoLetivo: new Date().getFullYear(),
  };

  componentDidMount = () => {
    const usuario = localStorageService.getItem("auth_user");
    const anoLetivo = parseInt(localStorageService.getItem("anoletivo"));

    this.setState({ anoLetivo });

    if (usuario !== null) {
      this.setState({ usuario: usuario.nmUsuario });

      GetEscola().then((retorno) => {
        const { data } = retorno;

        if (data.txLogo === "") data.txLogo = "/assets/images/logo-top.jpg";

        this.setState({ icone: data.txLogo });
      });
    }
  };

  handleMenuClick = () => {
    let { setLayoutSettings, settings } = this.props;
    setLayoutSettings(
      merge({}, settings, {
        layout1Settings: {
          leftSidebar: {
            open: settings.layout1Settings.leftSidebar.secondaryNavOpen
              ? true
              : !settings.layout1Settings.leftSidebar.open,
            secondaryNavOpen: false,
          },
        },
      })
    );
  };

  toggleFullScreen = () => {
    if (document.fullscreenEnabled) {
      if (!document.fullscreen) document.documentElement.requestFullscreen();
      else document.exitFullscreen();
    }
  };

  onChangeAnoLetivo = (value) => {
    this.setState({ anoLetivo: value }, () => {
      localStorage.setItem("anoletivo", value);
      window.location.reload();
    });
  };

  render() {
    let {
      shorcutMenuList = [],
      notificationList = [],
      icone,
      usuario,
      anoLetivo,
    } = this.state;

    return (
      <div className="main-header">
        <div className="logo">
          <img
            src="https://blobwebmagister.blob.core.windows.net/webmagisterapp/blobapp/logo-webmagister.png"
            style={{ height: "60px", width: "auto" }}
          />
        </div>

        <div className="menu-toggle" onClick={this.handleMenuClick}>
          <div></div>
          <div></div>
          <div></div>
        </div>
        {/*
          <div className="d-none d-lg-flex align-items-center">
            <Dropdown className="mr-3">
              <Dropdown.Toggle as="span" className="toggle-hidden cursor-pointer">
                Mega Menu
            </Dropdown.Toggle>

              <div className="mega-menu">
                <Dropdown.Menu>
                  <MegaMenu></MegaMenu>
                </Dropdown.Menu>
              </div>
            </Dropdown>
          </div>
        */}

        <div style={{ margin: "auto" }}>
          {(() => {
            return (
              <Dropdown key={`ddAnoLetivo`}>
                <Dropdown.Toggle
                  title={"Ano letivo corrente"}
                  variant={`primary`}
                  className="mr-3 mb-3"
                  size="lg"
                >
                  {anoLetivo}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {(() => {
                    const anoLetivoMaximo = new Date().getFullYear() + 1;
                    const anoLetivoMinimo = anoLetivoMaximo - 6;
                    const retorno = [];

                    for (
                      let index = anoLetivoMaximo;
                      index > anoLetivoMinimo;
                      index--
                    ) {
                      retorno.push(
                        <Dropdown.Item
                          key={index}
                          onClick={() => this.onChangeAnoLetivo(index)}
                        >
                          &nbsp;{index}&nbsp;
                        </Dropdown.Item>
                      );
                    }

                    return retorno;
                  })()}
                </Dropdown.Menu>
              </Dropdown>
            );
          })()}
        </div>

        <div className="header-part-right">
          <i
            className="i-Full-Screen header-icon d-none d-sm-inline-block"
            data-fullscreen
            onClick={this.toggleFullScreen}
          ></i>
          {/*
          <Dropdown>
            <Dropdown.Toggle as="span" className="toggle-hidden cursor-pointer">
              <div
                className="badge-top-container"
                role="button"
                id="dropdownNotification"
                data-toggle="dropdown"
              >
                <span className="badge badge-primary">3</span>
                <i className="i-Bell text-muted header-icon"></i>
              </div>
            </Dropdown.Toggle>

            <DropdownMenu className="notification-dropdown rtl-ps-none">
              {notificationList.map((note, index) => (
                <div key={index} className="dropdown-item d-flex">
                  <div className="notification-icon">
                    <i className={`${note.icon} text-${note.color} mr-1`}></i>
                  </div>
                  <div className="notification-details flex-grow-1">
                    <p className="m-0 d-flex align-items-center">
                      <span>{note.title}</span>
                      <span
                        className={`badge badge-pill badge-${note.color} ml-1 mr-1`}
                      >
                        {note.status}
                      </span>
                      <span className="flex-grow-1"></span>
                      <span className="text-small text-muted ml-auto">
                        {getTimeDifference(new Date(note.time))} ago
                      </span>
                    </p>
                    <p className="text-small text-muted m-0">
                      {note.description}
                    </p>
                  </div>
                </div>
              ))}
            </DropdownMenu>
          </Dropdown>
          */}

          <div
            className="user col align-self-end"
            style={{ marginRight: "0px" }}
          >
            <Dropdown>
              <DropdownToggle
                as="span"
                className="toggle-hidden cursor-pointer"
              >
                <img
                  src={icone}
                  style={{ height: "36px", width: "auto" }}
                  id="userDropdown"
                  alt=""
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                />
              </DropdownToggle>
              <DropdownMenu>
                <div className="dropdown-header">
                  <i className="i-Lock-User mr-1"></i>
                  {usuario}
                </div>
                <Link
                  to="/escola/parametros"
                  className="dropdown-item cursor-pointer"
                >
                  Configurações
                </Link>
                <a
                  href="https://webmagister.zendesk.com/hc/pt-br"
                  className="dropdown-item cursor-pointer"
                  target="_blank"                  
                >
                  Central de Ajuda
                </a>
                <Link
                  to="/"
                  className="dropdown-item cursor-pointer"
                  onClick={this.props.logoutUser}
                >
                  Sair
                </Link>
              </DropdownMenu>
            </Dropdown>
          </div>
          <div className="col align-self-end">
            <a href={"https://webmagister.zendesk.com/hc/pt-br"} target="blank">
              <img
                src="/assets/images/wm-faq-icon.png"
                style={{ width: "30px", height: "30px" }}
              />
            </a>
          </div>
        </div>
      </div>
    );
  }
}

Layout1Header.propTypes = {
  setLayoutSettings: PropTypes.func.isRequired,
  setDefaultSettings: PropTypes.func.isRequired,
  logoutUser: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  setDefaultSettings: PropTypes.func.isRequired,
  setLayoutSettings: PropTypes.func.isRequired,
  logoutUser: PropTypes.func.isRequired,
  user: state.user,
  settings: state.layout.settings,
});

export default withRouter(
  connect(mapStateToProps, {
    setLayoutSettings,
    setDefaultSettings,
    logoutUser,
  })(Layout1Header)
);
